//#region actual theme-editor types
export var ThemeEditorCssClass;
(function (ThemeEditorCssClass) {
    ThemeEditorCssClass["Base"] = "iress-theme-editor";
})(ThemeEditorCssClass || (ThemeEditorCssClass = {}));
export var ThemeEditorValueTypeComponent;
(function (ThemeEditorValueTypeComponent) {
    ThemeEditorValueTypeComponent["Input"] = "input";
    ThemeEditorValueTypeComponent["Select"] = "select";
})(ThemeEditorValueTypeComponent || (ThemeEditorValueTypeComponent = {}));
export var ThemeSpecValueType;
(function (ThemeSpecValueType) {
    ThemeSpecValueType["Number"] = "num";
    ThemeSpecValueType["Rem"] = "rem";
    ThemeSpecValueType["Pixels"] = "px";
    ThemeSpecValueType["Seconds"] = "s";
    ThemeSpecValueType["HSLA"] = "hsla";
    ThemeSpecValueType["Color"] = "color";
    ThemeSpecValueType["Font"] = "font";
    ThemeSpecValueType["Text"] = "text";
})(ThemeSpecValueType || (ThemeSpecValueType = {}));
export var ThemeConfigExtendsClassName;
(function (ThemeConfigExtendsClassName) {
    ThemeConfigExtendsClassName["IressThemeLight"] = "iress-theme-light";
    ThemeConfigExtendsClassName["IressThemeDark"] = "iress-theme-dark";
})(ThemeConfigExtendsClassName || (ThemeConfigExtendsClassName = {}));
//#endregion
//# sourceMappingURL=theme-editor.types.js.map